import request from "./client";

export const getById = async ({ id }) => {
  const resp = await request.get(`/v1/work_orders/${id}`);
  return { data: resp.body };
};

export const getSome = async ({ q = "", filter = "", limit = 10, offset = 0, sort_by = "", sort_dir = "" }) => {
  const query = new URLSearchParams({
    limit,
    offset,
    ...(filter && { filter }),
    ...(q && { q }),
    ...(sort_by && { sort_by }),
    ...(sort_dir && { sort_dir }),
  }).toString();
  try {
    const resp = await request.get(`/v1/work_orders?${query}`);
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response };
  }
};

export const createOne = async ({
  scheduled_from,
  scheduled_until,
  availability_from,
  availability_until,
  remark,
  remark_summary,
  customer,
  customer_property,
  assigned_to_id,
  uploads,
}) => {
  try {
    const resp = await request.post("/v1/work_orders").send({
      scheduled_from,
      scheduled_until,
      availability_from,
      availability_until,
      remark,
      remark_summary,
      customer,
      customer_property,
      assigned_to_id,
      uploads,
    });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const updateOne = async ({
  id,
  version,
  scheduled_from,
  scheduled_until,
  availability_from,
  availability_until,
  remark,
  remark_summary,
  customer,
  customer_property,
  assigned_to_id,
  uploads,
}) => {
  try {
    const resp = await request.put(`/v1/work_orders/${id}`).send({
      version,
      scheduled_from,
      scheduled_until,
      availability_from,
      availability_until,
      remark,
      remark_summary,
      customer,
      customer_property,
      assigned_to_id,
      uploads,
    });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const assignWorkOrder = async ({ id, assigned_to_id }) => {
  try {
    const resp = await request.patch(`/v1/work_orders/${id}/assign`).send({ assigned_to_id });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const assignMe = async ({ id }) => {
  try {
    const resp = await request.post(`/v1/work_orders/${id}/assign-me`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const cancelWorkOrder = async ({ id }) => {
  try {
    const resp = await request.post(`/v1/work_orders/${id}/cancel`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const linkDeliveryNote = async ({ id, delivery_note_id }) => {
  try {
    const resp = await request.post(`/v1/work_orders/${id}/delivery_notes`).send({ delivery_note_id });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const unlinkDeliveryNote = async ({ id, deliveryNoteId }) => {
  try {
    const resp = await request.delete(`/v1/work_orders/${id}/delivery_notes/${deliveryNoteId}`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const deleteFile = async ({ id, fileId }) => {
  try {
    await request.delete(`/v1/work_orders/${id}/files/${fileId}`);
    return { error: null };
  } catch (e) {
    if (!e.response) {
      return { error: e };
    }
    return { error: e.response.body };
  }
};

export const addComment = async ({ id, text }) => {
  try {
    const resp = await request
      .post(`/v1/work_orders/${id}/comments`)
      .send({ text });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const updateComment = async ({ id, commentId, text }) => {
  try {
    const resp = await request
      .put(`/v1/work_orders/${id}/comments/${commentId}`)
      .send({ text });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const deleteComment = async ({ id, commentId }) => {
  try {
    await request.delete(`/v1/work_orders/${id}/comments/${commentId}`);
    return { error: null };
  } catch (e) {
    if (!e.response) {
      return { error: e };
    }
    return { error: e.response.body };
  }
};

export const extractFromText = async ({ text }) => {
  try {
    const resp = await request.post("/v1/work_orders/assistant/extract").send({ text });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
